import { render, staticRenderFns } from "./FundraisingDetails.vue?vue&type=template&id=dfc6d32e"
import script from "./FundraisingDetails.vue?vue&type=script&lang=js"
export * from "./FundraisingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports